import styled from 'styled-components'

export const FinalPreviewContainer = styled.div`
  .actions {
    justify-content: flex-start;
    padding-bottom: 1rem;
  }
`
